import { downloadBlob } from "../http/downloadBlob";
import type { SubmissionSyncSidecar } from "../../types/submissionSync";

export const MIN_SYNC_EXPIRES_IN_DAYS = 1;
export const MAX_SYNC_EXPIRES_IN_DAYS = 30;
export const DEFAULT_SYNC_EXPIRES_IN_DAYS = 14;

export function clampSyncExpiresInDays(value: number): number {
  if (!Number.isFinite(value)) return DEFAULT_SYNC_EXPIRES_IN_DAYS;
  return Math.min(
    MAX_SYNC_EXPIRES_IN_DAYS,
    Math.max(MIN_SYNC_EXPIRES_IN_DAYS, Math.trunc(value)),
  );
}

export function sidecarFilenameFromExcel(excelName: string): string {
  const trimmed = excelName.trim() || "submissions.xlsx";
  const base = trimmed.replace(/\.(xlsx|xlsm|xls|csv)$/i, "");
  return `${base}.chm-sync.json`;
}

/** CHM-sidecar на диск: без token / секрета. */
export function sidecarForDisk(
  sidecar: SubmissionSyncSidecar,
): Record<string, unknown> {
  const columns = {
    headers: sidecar.columns.headers,
    fieldIds: sidecar.columns.fieldIds,
    metaKeys: sidecar.columns.metaKeys,
    orderIds: sidecar.columns.orderIds,
    staffColumnIds: sidecar.columns.staffColumnIds,
  };

  if (sidecar.auth === "token") {
    return {
      version: sidecar.version || 1,
      auth: "token",
      apiBase: sidecar.apiBase,
      formId: sidecar.formId,
      token: sidecar.token,
      expiresAt: sidecar.expiresAt ?? null,
      includeStaffMarks: sidecar.includeStaffMarks,
      columns,
      cursor: sidecar.cursor,
      endpoints: sidecar.endpoints,
      authHint: sidecar.authHint,
    };
  }

  return {
    version: sidecar.version || 2,
    auth: "chm",
    apiBase: sidecar.apiBase,
    formId: sidecar.formId,
    includeStaffMarks: sidecar.includeStaffMarks,
    columns,
    cursor: sidecar.cursor,
    endpoints: sidecar.endpoints,
    authHint:
      sidecar.authHint ??
      "form.auth: X-User-Id … или Bearer. Секрет в файл не писать.",
  };
}

export function downloadSubmissionSyncSidecar(
  sidecar: SubmissionSyncSidecar,
  filename: string,
): void {
  const blob = new Blob(
    [`${JSON.stringify(sidecarForDisk(sidecar), null, 2)}\n`],
    {
      type: "application/json",
    },
  );
  downloadBlob(blob, filename);
}
